import { defineComponent } from 'vue';
import EngineerSettingsACSystem from '../../../_shared/engineer/EngineerSettingsACSystem.vue';
export default defineComponent({
    name: 'EngineerSettingsSmartModuleACSystemContainer',
    components: {
        EngineerSettingsACSystem,
    },
    props: {
        data: {
            type: Object,
            required: true,
        },
        editable: {
            type: Boolean,
            default: false,
        },
        hideEdit: {
            type: Boolean,
            default: false,
        },
        isConnection: {
            type: Boolean,
            required: true,
        },
        isHcore: {
            type: Boolean,
            default: false,
        },
        isQcore: {
            type: Boolean,
            default: false,
        },
        isAcCoupled: {
            type: Boolean,
            default: false,
        },
        siteId: {
            type: Number,
            default: null,
        },
    },
    emits: ['goToList', 'save', 'cancel', 'edit'],
    async setup(props, { emit }) {
        function onSave(params, callback) {
            emit('save', params, callback);
        }
        function onEdit(copyData) {
            emit('edit', copyData);
        }
        return {
            onSave,
            onEdit,
        };
    },
});
